// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZfMx","type":"styles_type__1hfpa","choices":"styles_choices__1mC0H"};